import { MarketTimes, MarketTimeWindow, CurrentSession } from '../types';

interface SessionTimes {
  open: string;
  close: string;
}

interface Sessions {
  'pre-market': SessionTimes;
  market: SessionTimes;
  'after-market': SessionTimes;
}

export const getNextMarketWindows = (): MarketTimes => {
  const now = new Date();
  let nowInNY = new Date(
    now.toLocaleString("en-US", { timeZone: "America/New_York" })
  );

  function getWeekday(date: Date): Date {
    const day = date.getDay();
    const result = new Date(date);
    if (day === 6) result.setDate(result.getDate() + 2); // Sat → Mon
    else if (day === 0) result.setDate(result.getDate() + 1); // Sun → Mon
    return result;
  }

  nowInNY = getWeekday(nowInNY);

  const sessions: Sessions = {
    "pre-market": { open: "04:00", close: "09:30" },
    market: { open: "09:30", close: "16:00" },
    "after-market": { open: "16:00", close: "20:00" },
  };

  const result: Partial<MarketTimes> = {};
  let currentSession: CurrentSession | null = null;

  for (const [label, { open, close }] of Object.entries(sessions) as [keyof Sessions, SessionTimes][]) {
    const baseDate = new Date(nowInNY);
    const dateStr = baseDate.toLocaleDateString("en-CA", {
      timeZone: "America/New_York",
    });

    let openDateStr = `${dateStr}T${open.padStart(5, "0")}:00`;
    let closeDateStr = `${dateStr}T${close.padStart(5, "0")}:00`;

    const offset = nowInNY
      .toLocaleTimeString("en-us", {
        timeZoneName: "short",
        timeZone: "America/New_York",
      })
      .split(" ")[2]; // EDT or EST

    const tzOffset = offset === "EDT" ? "-04:00" : "-05:00";
    openDateStr += tzOffset;
    closeDateStr += tzOffset;

    let openTime = new Date(openDateStr);
    let closeTime = new Date(closeDateStr);

    function skipWeekends(date: Date): Date {
      const d = new Date(date);
      const day = d.getDay();
      if (day === 6) d.setDate(d.getDate() + 2);
      else if (day === 0) d.setDate(d.getDate() + 1);
      return d;
    }

    if (closeTime <= nowInNY) {
      openTime = skipWeekends(new Date(openTime));
      closeTime = skipWeekends(new Date(closeTime));
    }

    if (openTime <= nowInNY && closeTime > nowInNY) {
      currentSession = {
        label,
        open: Math.floor(openTime.getTime() / 1000),
        close: Math.floor(closeTime.getTime() / 1000),
      };
    }

    result[label] = {
      open: Math.floor(openTime.getTime() / 1000),
      close: Math.floor(closeTime.getTime() / 1000),
    };
  }

  const overallOpen = result["pre-market"]!.open;
  const overallClose = result["after-market"]!.close;

  if (Math.floor(nowInNY.getTime() / 1000) <= overallClose && currentSession) {
    result.current = currentSession;
  }

  result.overall = {
    open: overallOpen,
    close: overallClose,
  };

  return result as MarketTimes;
};
